import { queryOptions, useQuery } from '@tanstack/react-query';

import { stonePricingApi } from '../api/stone-pricing-api';

import { dictionaryKeys } from './dictionary-keys';

export function stonePriceRulesQueryOptions() {
  return queryOptions({
    queryKey: dictionaryKeys.stonePriceRules(),
    queryFn: stonePricingApi.list,
  });
}

export function useStonePriceRules() {
  return useQuery(stonePriceRulesQueryOptions());
}
